// Words the design system has asked him about and draws as pending meanwhile (BUILD-ORDER §3.4: "words are drawn as
// pending on the gallery panel"). PENDING (glossary.generated.ts) is cut from the vendored sources and holds only the
// words they already list (G §23, Q-E15, T-8, Q-E16); a word asked since then waits here, with the question it is
// asked in. labels.test.mjs treats PENDING and ASKED together as the pending words, requires each ASKED word to be
// drawn by a pending label, and refuses one that the vendored PENDING already carries: once the sources list it, it
// leaves this list in the same commit as the re-vendor. A word is asked in one sense, named by the quote its pending
// label carries: *Close* the dialog's control is asked, while *Close* the requisition outcome (DS #25's his-words cell)
// stays his. Code-owned, never configuration; nothing here is rendered.

export interface AskedWord {
  /** The label text exactly as a pending label draws it ({slot} placeholders kept). */
  readonly text: string;
  /** The question it is asked in: one of the design system's open questions (Q-n) or the Q-E15 list it joins. */
  readonly ref: `Q-${number}` | `Q-E${number}`;
  /** The verbatim line the pending label quotes: the sense that is asked. */
  readonly quote: string;
}

export const ASKED: readonly AskedWord[] = Object.freeze([
  // #60 Dialog / #61 SlideOver: the close button's own name, so a Cancel dialog never carries three controls named Cancel.
  { text: "Close", ref: "Q-3", quote: "focus trapped, Escape closes, focus returns" },
  // DS §2.4's timeline row for a recorded reference check: a line assembled from his words, routed to Q-E15 (the
  // DS-owner default) until the vendored Q-E15 list carries it.
  {
    text: "{actor} recorded the reference check · {status}",
    ref: "Q-E15",
    quote: "the timeline row reads \"{actor} recorded the reference check · {status}\"",
  },
  // DC-45's sort control and tier-filter name (the Action Center, plan D17 DCR-B10-1): the design column names it, no
  // his-words cell does, so it joins the Q-E15 list (the DS-owner default) until the vendored list carries it.
  {
    text: "Priority",
    ref: "Q-E15",
    quote: "Priority is the SLA tier; groups *Breach — dashboard risk · Near-breach · Reminder · Due*; sort *Priority · Due · Requisition*; kind chips in his nine words.",
  },
  // DS §3.4 draws an assigned skill by its name and retires V1's numbered *Skill #n*. Where a screen holds only the
  // skill's number (an untitled skill in the plan, a kickoff row of numbers, the #91 scores row without names), his
  // *Skill* (DS #57's lane words) and the number stand in, joining the Q-E15 list (the DS-owner default) until he
  // names the stand-in or every screen holds the name.
  {
    text: "Skill {n}",
    ref: "Q-E15",
    quote: "*Interviewer* · the *virtual / onsite / hybrid* `seg` (no label) · *Executive participation · ROOTS · Skill · Load*",
  },
  // Q-E15 asks "Recovery is available to TA Admin and HR Systems Admin"; DC-228 folds both into the one Admin, so the
  // sentence draws the role as a slot (Admin) and stays pending in the same question until the vendored list re-words it.
  { text: "Recovery is available to {role}", ref: "Q-E15", quote: "*Recovery is available to TA Admin and HR Systems Admin*" },
]);
